import { datalayerPush } from "./GTM";

// NOTICE! This only works for accordions added in Razor views since they're rendered initially (and React-rendered accordions, e.g. in the menu, aren't present when this initializes)
class Accordions {
    accordions: NodeListOf<HTMLButtonElement>;
    faqAccordions: NodeListOf<HTMLButtonElement>;

    constructor() {
        this.accordions = document.querySelectorAll(
            ".accordion-trigger",
        ) as NodeListOf<HTMLButtonElement>;
        this.faqAccordions = document.querySelectorAll(
            ".faq-accordion-trigger",
        ) as NodeListOf<HTMLButtonElement>;

        this.addListeners();
        this.addFaqAccordionTracking();
    }

    addListeners() {
        this.accordions.forEach((button) => {
            const contentId = button.getAttribute("aria-controls")!;
            const content = document.getElementById(contentId)!;

            button.addEventListener("click", () => {
                const isOpen = button.getAttribute("aria-expanded") === "true";
                button.setAttribute("aria-expanded", `${!isOpen}`);
                content.setAttribute("aria-hidden", `${isOpen}`);

                if (isOpen) {
                    this.collapse(content);
                } else {
                    this.expand(content);
                }
            });
        });
    }

    expand(content: HTMLElement) {
        content.style.display = "block";
        const height = content.scrollHeight + "px";
        content.style.maxHeight = "0";
        requestAnimationFrame(() => {
            content.style.transition = "max-height 200ms ease-out";
            content.style.maxHeight = height;
        });

        content.addEventListener(
            "transitionend",
            () => {
                content.style.maxHeight = "none";
            },
            { once: true },
        );
    }

    collapse(content: HTMLElement) {
        content.style.maxHeight = content.scrollHeight + "px";
        requestAnimationFrame(() => {
            content.style.transition = "max-height 200ms ease-out";
            content.style.maxHeight = "0";
        });

        content.addEventListener(
            "transitionend",
            () => {
                content.style.display = "none";
            },
            { once: true },
        );
    }

    addFaqAccordionTracking() {
        this.faqAccordions.forEach((button) => {
            button.addEventListener("click", () => {
                const isOpen = button.getAttribute("aria-expanded") === "true";
                const text = button.innerText;

                // Timing is important - addListeners above has already toggled the aria-expanded on it
                if (isOpen) {
                    datalayerPush({ event: "faq_expand", faq_question: text });
                }
            });
        });
    }
}

export default Accordions;
